<template>
    <div>
        <b-container fluid="xl" class="bv-example-row">
            <b-row>
                <b-col md="4">
                    <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
                </b-col>
            </b-row>
        </b-container>
        <span v-if="loading">
            <b-spinner label="Spinning"></b-spinner>
        </span>
        <b-alert :show="loadError" variant="danger">
            {{$t(identitySaved ? 'device_identity_reload_error' : 'additional_load_error')}}
            <b-button size="sm" @click="loadData">{{$t('retry')}}</b-button>
        </b-alert>
        <b-alert v-if="identitySaved && !loading && !loadError" class="identity-confirmed" variant="success" show>{{$t('saved_successful')}}</b-alert>
        <span v-if="!loading && !loadError">
            <device-settings
                :device-id="device.id"
                :device-type-id="device.typeId"
                :device-imei="device.imei"
                :section="section"
                @identity:pending="identitySaved = false"
                @identity:changed="identityChanged"
            />
        </span>
    </div>
</template>

<script>
    import axios from "axios";
    import DeviceSettings from "../DeviceSettings/DeviceSettings";


    export default {
        name: "Device",
        components: {DeviceSettings},
        props: [
            "id",
            "section"
        ],
        data() {
            return {
                loading: true,
                loadError: false,
                identitySaved: false,
                loadRequestId: 0,
                disposed: false,
                breadcrumb: [
                    {
                        text: this.$t('menu.devices'),
                        href: '#/devices'
                    }, {
                        text: this.$t('menu.device_settings')
                    }
                ],
                deviceTypeId: null,
                device: {
                    id: null,
                    typeId: null,
                    imei: null
                }
            }
        },
        mounted() {
            this.loadData();
        },
        beforeDestroy() { this.disposed = true; this.loadRequestId++; },
        watch: { id() { this.identitySaved = false; this.loadData(); } },
        methods: {
            identityChanged() { this.identitySaved = true; return this.loadData(); },
            loadData() {
                if (this.disposed) return;
                const requestId = ++this.loadRequestId;
                this.loading = true;
                this.loadError = false;
                return axios.get('api/v1/devices/' + this.id)
                    .then(response => {
                        if (this.disposed || requestId !== this.loadRequestId) return;
                        this.device = { id: response.data.id, typeId: response.data.typeId, imei: response.data.imei };
                    })
                    .catch(() => { if (!this.disposed && requestId === this.loadRequestId) this.loadError = true; })
                    .finally(() => { if (!this.disposed && requestId === this.loadRequestId) this.loading = false; });
            },
        },
    }
</script>

<style scoped>

</style>
